import React from 'react';
import { useFilterValues } from '../../../../api/data/hooks';
import { FilterDataManager } from '../../../../api/data/types';
import { GlobalFilterTypeHandle } from '../../../../context/types';
import { FilterTypes } from '../filterbar/types';
import { HierarchyItem } from '../types';
import { FilterTrayItemsMemo } from './FilterTrayItems';

interface FilterTraySectionProps<T extends FilterTypes> {
  subItems: HierarchyItem[] | null;
  hierarchyRef: React.MutableRefObject<HierarchyItem[] | null>;
  filterHandle: GlobalFilterTypeHandle<T>;
  filterDataManager: FilterDataManager;
  forceOpen: boolean;
}

const NoDataFilter = () => {
  return <div style={{ padding: '5px', textAlign: 'center' }}>No data</div>;
};

export const FilterTraySection = <T extends FilterTypes>(
  props: FilterTraySectionProps<T>
) => {
  const { subItems, hierarchyRef, filterHandle, filterDataManager, forceOpen } =
    props;
  const { data: hierarchyItem } = useFilterValues(filterDataManager);
  hierarchyRef.current = hierarchyItem;
  const items = subItems ?? hierarchyItem;
  return (
    <>
      {!hierarchyItem && items ? (
        <NoDataFilter />
      ) : (
        <FilterTrayItemsMemo<T>
          items={items}
          filterHandle={filterHandle}
          forceOpen={forceOpen}
        />
      )}
    </>
  );
};
